import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { storage_keys } from '../../utils/storage';
import useLocalStorage from './useLocalStorage';
import { GlobalContext } from '../contexts/GlobalContext';
import { differenceInHours } from 'date-fns';
import useSWR from 'swr';
export function useIsDegradedBanner() {
  const $ = _c(9);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const [dismissed_at, setDismissedAt] = useLocalStorage(`${storage_keys.degraded_banner_dismissed_at}`, null);
  let t0;
  if ($[0] !== dismissed_at) {
    t0 = dismissed_at && differenceInHours(new Date(), new Date(dismissed_at)) < 24;
    $[0] = dismissed_at;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const dismissed_recently = t0;
  let t1;
  if ($[2] !== HookdeckAPI.status) {
    t1 = () => HookdeckAPI.status.getServiceStatus();
    $[2] = HookdeckAPI.status;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: status
  } = useSWR("status", t1);
  const t2 = status?.status === "degraded" && !dismissed_recently;
  let t3;
  if ($[4] !== setDismissedAt) {
    t3 = () => {
      setDismissedAt(new Date().toISOString());
    };
    $[4] = setDismissedAt;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      is_degraded_banner_active: t2,
      setDismissedAt: t3
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}